import React, { useState } from "react";
import { ToolsKPIsData } from "../../../components/partials/box";

interface SelectionStepProps {
  formInfo: any[];
  handleKpi: (
    event: React.ChangeEvent<HTMLInputElement>,
    formIndex: number,
    kpiIndex: number
  ) => void;
  setInfo: (info: any) => void;
  others?: any;
  selectedFeatures: string[];
  setSelectedFeatures: (features: string[]) => void;
}

const SelectionStep: React.FC<SelectionStepProps> = ({
  formInfo,
  handleKpi,
  setInfo,
  others,
  selectedFeatures,
  setSelectedFeatures,
}) => {
  // Define features that match the new UI
  const features = [
    {
      id: "inter-system",
      label: "Inter-system Integration",
    },
    {
      id: "desktop-mobile",
      label: "Desktop-based, mobile or web-based",
    },
    {
      id: "national-reporting",
      label:
        "Has national and sub-national reporting linkages with other tools",
    },
    {
      id: "interfaces",
      label: "Interfaces for data entry, visualization, and analysis",
    },
    {
      id: "low-connectivity",
      label: "Usable in low-connectivity areas",
    },
    {
      id: "multiple-sources",
      label: "Collects data from multiple sources (operations, surveys, etc.)",
    },
    {
      id: "standardised-indicators",
      label:
        "Uses standardised indicators (like national KPIs from WSH regulator) to facilitate comparison",
    },
    {
      id: "continuous-collection",
      label: "Supports continuous or scheduled data collection",
    },
    {
      id: "data-verification",
      label: "Incorporates mechanisms for data verification and error checking",
    },
    {
      id: "service-chain",
      label:
        "Can be used at various stages of the WSH service chain (planning, operations etc)",
    },
    {
      id: "dashboards",
      label:
        "Has dashboards and maps that enable quick interpretation through GIS, charts, graphs, and tables",
    },
    {
      id: "data-aggregation",
      label: "Aggregates data from local to national or regional levels",
    },
    {
      id: "analytical-tools",
      label:
        "Has analytical tools to support planning and resource allocation, and decision making",
    },
    {
      id: "training-support",
      label: "Provides training and support for users",
    },
    {
      id: "cost-effective",
      label:
        "Cost-effective in terms of acquisition and operation for long-term use and updates",
    },
  ];

  const handleFeatureToggle = (featureId: string) => {
    const newFeatures = selectedFeatures.includes(featureId)
      ? selectedFeatures.filter((id) => id !== featureId)
      : [...selectedFeatures, featureId];

    setSelectedFeatures(newFeatures);

    // Log selected features in API format
    console.log("Step 3 - features:", newFeatures);
  };

  return (
    <div className="space-y-8 bg-white w-full p-8">
      <div className="h-full lg:w-2/3 pb-3 border-b">
        <h1 className="text-2xl font-semibold text-da-blue-600 inter">
          Select all features that apply to your tool
        </h1>
        <p className="text-sm text-gray-600 mt-2">
          Choose the features that best describe your tool's capabilities
        </p>
      </div>

      <div className="space-y-6 lg:w-2/3">
        {/* New Feature Selection UI */}
        <div className="grid gap-4 md:grid-cols-2">
          {features.map((feature) => {
            const isChecked = selectedFeatures.includes(feature.id);
            return (
              <div
                key={feature.id}
                className={`flex items-start gap-3 rounded-lg border p-4 transition-colors ${
                  isChecked
                    ? "border-blue-500 bg-blue-50"
                    : "border-gray-300 bg-white"
                }`}
              >
                <input
                  type="checkbox"
                  id={feature.id}
                  checked={isChecked}
                  onChange={() => handleFeatureToggle(feature.id)}
                  className="mt-0.5 h-4 w-4 text-blue-600 border-gray-300 rounded focus:ring-blue-500"
                />
                <label
                  htmlFor={feature.id}
                  className="cursor-pointer text-sm font-normal leading-relaxed text-gray-900"
                >
                  {feature.label}
                </label>
              </div>
            );
          })}
        </div>

        {/* Original KPI Selection (preserved for existing functionality) */}
        {/* <div className="mt-8">
          <h3 className="text-lg font-semibold text-da-blue-600 mb-4">
            Final Selection Review
          </h3>
          <p className="text-sm text-gray-600 mb-4">
            Review your KPI selections before submitting
          </p>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {formInfo?.map((tool: any, i: number) => (
              <ToolsKPIsData
                key={i}
                start
                data={tool?.data}
                title={tool?.category}
                selection
                handleKpi={handleKpi}
                formIndex={i}
                shadow
                setInfo={() => setInfo(tool)}
                prevData={others?.kpiSelection || null}
              />
            ))}
          </div>
        </div> */}
      </div>
    </div>
  );
};

export default SelectionStep;
